import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatPartnerUnlinkedPayload = z.object({
    partnerId: schemaId,
});

export type Schema_ChatPartnerUnlinkedPayload = z.infer<typeof schemaChatPartnerUnlinkedPayload>;
